:host {
    @include grid;

    padding: 48px 0 42px;

    .content-wrapper {
        grid-column: 2 / -2;
        display: grid;
        column-gap: var(--column-gap);
        row-gap: 40px;
        grid-template-columns: repeat(auto-fit, minmax(var(--min-width), 1fr));
    }

    .search-area {
        display: flex;
        gap: 20px;
        align-items: flex-start;

        sew-ws-button {
            flex-shrink: 0;
            height: 48px;
        }
    }

    .address-area {
        font-weight: bolder;
        font-style: normal;
        font-size: 18px;
        white-space: nowrap;
        justify-self: start;
    }

    .error-message {
        @include typo-ws-paragraph;

        margin: 0;
        white-space: normal;
    }
}

@include mq-2 {
    :host {
        .content-wrapper {
            grid-template-columns: 1fr 1fr;
        }
    }
}

@include mq-1 {
    :host {
        padding: 40px 0 42px;

        .content-wrapper {
            grid-template-columns: 1fr;
        }

        .search-area {
            flex-direction: column;
            align-items: stretch;
        }

        .address-area:empty {
            display: none;
        }
    }
}
